const COOKIE_PREFIX = 'mainstem_beta_invite_declined_'
const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365

const cookieName = (userId: string) => `${COOKIE_PREFIX}${userId}`

export const hasDeclinedBetaInvite = (userId: string): boolean => {
  const name = cookieName(userId)
  return document.cookie.split('; ').some((part) => part.startsWith(`${name}=`))
}

export const rememberBetaInviteDeclined = (userId: string): void => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${cookieName(userId)}=1; Max-Age=${ONE_YEAR_IN_SECONDS}; path=/; SameSite=Lax${secure}`
}
